import * as custom from './marketplace-custom-config.js';
import defaultLocationSearches from './default-location-searches';
import { stripePublishableKey, stripeCountryDetails } from './stripe-config';
import { currencyConfiguration } from './currency-config';

const env = process.env.REACT_APP_ENV;
const dev = process.env.REACT_APP_ENV === 'development';

const locale = 'en';
const i18n = {
  firstDayOfWeek: 0,
};

const sortSearchByDistance = false;

const bookingProcessAlias = {
  classic: 'unit-booking-1/release-1',
  premium: 'unit-booking-1/release-1',
};

const bookingUnitType = 'line-item/units';

const enableAvailability = process.env.REACT_APP_AVAILABILITY_ENABLED === 'true';

const dayCountAvailableForBooking = 90;

const sdkClientId = process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID;
const sdkBaseUrl = process.env.REACT_APP_SHARETRIBE_SDK_BASE_URL;
const sdkTransitVerbose = process.env.REACT_APP_SHARETRIBE_SDK_TRANSIT_VERBOSE === 'true';

const currency = process.env.REACT_APP_SHARETRIBE_MARKETPLACE_CURRENCY;

const currencyConfig = currencyConfiguration(currency);

const listingMinimumPriceSubUnits = 0;

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

const usingSSL = process.env.REACT_APP_SHARETRIBE_USING_SSL === 'true';

const addressCountry = '';
const addressRegion = '';
const postalCode = '';
const streetAddress = '';

const canonicalRootURL = process.env.REACT_APP_CANONICAL_ROOT_URL;

const siteTitle = 'Viveka';

const siteTwitterHandle = '@viveka_world';

const siteInstagramPage = null;

const siteFacebookPage = 'https://www.facebook.com/Sharetribe/';

const facebookAppId = null;

const maps = {
  mapboxAccessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
  googleMapsAPIKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  search: {
    suggestCurrentLocation: process.env.REACT_APP_DEFAULT_SEARCHES_ENABLED === 'true',
    currentLocationBoundsDistance: 1000,
    defaults:
      process.env.REACT_APP_DEFAULT_SEARCHES_ENABLED === 'true' ? defaultLocationSearches : [],
  },
  fuzzy: {
    enabled: false,
    offset: 500,
    defaultZoomLevel: 13,
    circleColor: '#c0392b',
  },
  customMarker: {
    enabled: false,
    url: encodeURI(`${canonicalRootURL}/static/icons/map-marker-32x32.png`),
    width: 32,
    height: 32,
    anchorX: 16,
    anchorY: 32,
  },
};
const subscriptionServiceUrl = process.env.REACT_APP_SUBSCRIPTION_SERVICE_URL;
const listingService = process.env.REACT_APP_LISTING_SERVICE_URL;
const chargebeeSiteName = process.env.REACT_APP_CHARGEBEE_SITENAME;
const firstMoverCutoffDate = process.env.REACT_APP_GRANDFATHER_CUTOFF_DATE;
const firstMoverOfferEndDate = process.env.REACT_APP_FIRST_MOVER_OFFER_END_DATE;
const contactService = process.env.REACT_APP_CONTACT_SERVICE_URL;
const coachSaaSService = process.env.REACT_APP_COACH_SAAS_URL;
const hubspotService = process.env.REACT_APP_HUBSPOT_SERVICE_URL;
const cookieTokenKey = process.env.REACT_APP_COOKIE_TOKEN_KEY;
const socketService = process.env.REACT_APP_SOCKET_SERVICE_URL;

const googleCalendarClientId = process.env.REACT_APP_GOOGLE_CALENDAR_CLIENT_ID;
const googleCalendarRedirectUri = process.env.REACT_APP_GOOGLE_CALENDAR_REDIRECT_URL;

const outlookTenantId = process.env.REACT_APP_OUTLOOK_TENANT_ID;
const outlookCalendarClientId = process.env.REACT_APP_OUTLOOK_CALENDAR_CLIENT_ID;
const outlookCalendarRedirectUri = process.env.REACT_APP_OUTLOOK_CALENDAR_REDIRECT_URL;

const appScope = process.env.REACT_APP_SCOPE;
const vCorpUrl = process.env.REACT_APP_V_CORP_URL;
const vcorpService = process.env.REACT_APP_VCORP_SERVICE_URL;

const config = {
  env,
  dev,
  locale,
  bookingProcessAlias,
  bookingUnitType,
  enableAvailability,
  dayCountAvailableForBooking,
  i18n,
  sdk: {
    clientId: sdkClientId,
    baseUrl: sdkBaseUrl,
    transitVerbose: sdkTransitVerbose,
  },
  sortSearchByDistance,
  currency,
  currencyConfig,
  listingMinimumPriceSubUnits,
  stripe: {
    publishableKey: stripePublishableKey,
    supportedCountries: stripeCountryDetails,
  },
  canonicalRootURL,
  address: {
    addressCountry,
    addressRegion,
    postalCode,
    streetAddress,
  },
  siteTitle,
  siteFacebookPage,
  siteInstagramPage,
  siteTwitterHandle,
  facebookAppId,
  sentryDsn,
  usingSSL,
  maps,
  custom,
  subscriptionServiceUrl,
  listingService,
  chargebeeSiteName,
  firstMoverCutoffDate,
  firstMoverOfferEndDate,
  contactService,
  coachSaaSService,
  hubspotService,
  cookieTokenKey,
  socketService,
  googleCalendarClientId,
  googleCalendarRedirectUri,
  outlookTenantId,
  outlookCalendarClientId,
  outlookCalendarRedirectUri,
  appScope,
  vCorpUrl,
  vcorpService,
};

export default config;
